/* eslint-disable prefer-rest-params */
import React, { useEffect, useRef, useState } from "react";
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
} from "chart.js";

Chart.register(
  BarController,
  BarElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title
);

const BarChartBorderRadius = ({ data }) => {
  const chartContainer = useRef(null);
  const [, setChartInstance] = useState(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      //   const context = chartContainer.current.getContext("2d");
      const context = chartContainer.current;
      const newChartInstance = new Chart(context, {
        type: "bar",
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "top",
            },
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
        data,
      });
      setChartInstance(newChartInstance);
    }
  }, [chartContainer, data]);

  return <canvas ref={chartContainer} />;
};

export default BarChartBorderRadius;
